(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 5557:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(4213);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7827:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Input; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _heroicons_react_24_outline__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2940);
/* harmony import */ var _heroicons_react_24_outline__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3023);



function Input(param) {
    let { title , name , type , register , errors , placeholder , min , max , notReq , background ="bg-gray-50" , disabled =false , valid  } = param;
    const [toggle, setToggle] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "w-full mx-auto",
        children: [
            errors && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "text-red-500 text-start w-full ",
                children: errors === null || errors === void 0 ? void 0 : errors.message
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "".concat(errors ? "border-red-600 " : "border-gray-500 ", " relative  border-b p-2  shadow-sm focus-within:border-indigo-600 focus:outline-none w-full "),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                        type: toggle || type,
                        placeholder: placeholder,
                        minlength: min,
                        maxlength: max,
                        disabled: disabled,
                        className: " block w-full border-0 p-0 text-softWhite placeholder-gray-500 bg-black focus:ring-0  focus:outline-none sm:text-xl",
                        ...register(name, {
                            required: notReq ? false : "Please enter a ".concat(name),
                            validate: valid || null
                        })
                    }),
                    type === "password" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        type: "button",
                        onClick: ()=>setToggle((current)=>current ? null : "text"),
                        className: "absolute top-2 right-6 text-gray-500 hover:text-gray-700",
                        children: toggle ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_24_outline__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            className: "h-5 w-5"
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_24_outline__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            className: "h-5 w-5"
                        })
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 7733:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ pageLoading; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

function pageLoading() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex justify-center items-center h-screen w-screen gap-5",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "h-6 w-6 opacity-80 rounded-full bg-jackOrange animate-oscillate ballOne"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "h-6 w-6 opacity-80 rounded-full bg-jackOrange animate-oscillate ballTwo"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "h-6 w-6 opacity-80 rounded-full bg-jackOrange animate-oscillate ballThree"
            })
        ]
    });
}


/***/ }),

/***/ 6337:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useOnboarding; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useMutation.js + 2 modules
var useMutation = __webpack_require__(1068);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 39 modules
var axios = __webpack_require__(594);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(7283);
;// CONCATENATED MODULE: ./lib/requests.js

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation submitJackalopeRequest(\n    $email: String!\n    $name: ID!\n    $employees: String!\n  ) {\n    submitJackalopeRequest(\n      numberOfEmployees: $employees\n      orgName: $name\n      requestEmail: $email\n    ) {\n      success\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation analyzeDoc($query: String!) {\n    analyzeDoc(query: $query) {\n      response\n      error\n    }\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation logInboundReferral($IP: String!, $ref: String!) {\n    logInboundReferral(affiliateReferenceId: $ref, prospectIdentifier: $IP) {\n      success\n      error\n    }\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation offerEmailCapture($email: String!) {\n    offerEmailCapture(email: $email) {\n      success\n    }\n  }\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation publicProjectValidation(\n    $email: String!\n    $endResultStatement: String!\n    $problemStatement: String!\n    $solutionStatement: String!\n  ) {\n    publicProjectValidation(\n      email: $email\n      endResultStatement: $endResultStatement\n      problemStatement: $problemStatement\n      solutionStatement: $solutionStatement\n    ) {\n      response\n      error\n    }\n  }\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation consultingLeadWeb(\n    $name: String!\n    $email: String!\n    $company: String!\n  ) {\n    companyLeadCapture(\n      companyPurpose: $company\n      fullName: $name\n      email: $email\n    ) {\n      success\n    }\n  }\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}

const SUBMIT_JACKALOPE = (0,lib/* gql */.Ps)(_templateObject());
const ASK = (0,lib/* gql */.Ps)(_templateObject1());
const LOG_REFERRAL = (0,lib/* gql */.Ps)(_templateObject2());
const EMAIL_CAPTURE = (0,lib/* gql */.Ps)(_templateObject3());
const VALIDATION = (0,lib/* gql */.Ps)(_templateObject4());
const LEAD = (0,lib/* gql */.Ps)(_templateObject5());

;// CONCATENATED MODULE: ./hooks/useOnboarding.js




// REQUESTS

const useDocuments = ()=>{
    const [openModal, setOpenModal] = (0,react.useState)(false);
    const [validation, setValidation] = (0,react.useState)({});
    const [response, setResponse] = (0,react.useState)(null);
    const router = (0,next_router.useRouter)();
    (0,react.useEffect)(()=>{
        const timer = setTimeout(()=>{
            setOpenModal(true);
        }, 40000); // 40 seconds
        return ()=>clearTimeout(timer);
    }, []);
    // REQUESTS
    /************************************************************************* */ const [inquire, inquiryResponse] = (0,useMutation/* useMutation */.D)(SUBMIT_JACKALOPE, {
        fetchPolicy: "network-only",
        onCompleted: (d)=>router.push("/thankyou"),
        onError: (d)=>alert(d)
    });
    const [logRef, refResponse] = (0,useMutation/* useMutation */.D)(LOG_REFERRAL, {
        fetchPolicy: "network-only",
        onCompleted: (d)=>console.log(d),
        onError: (d)=>console.log(d)
    });
    const [logEmail, emailResponse] = (0,useMutation/* useMutation */.D)(EMAIL_CAPTURE, {
        fetchPolicy: "network-only",
        onCompleted: (d)=>{
            if (openModal) setOpenModal(false);
            router.push("/thankyou");
        },
        onError: (d)=>console.log(d)
    });
    const [validate, validationResponse] = (0,useMutation/* useMutation */.D)(VALIDATION, {
        fetchPolicy: "network-only",
        onCompleted: (d)=>{
            setResponse(d.publicProjectValidation.response);
        },
        onError: (d)=>console.log(d)
    });
    const [logPriceEmail, priceResponse] = (0,useMutation/* useMutation */.D)(EMAIL_CAPTURE, {
        fetchPolicy: "network-only",
        onCompleted: (d)=>{
            if (openModal) setOpenModal(false);
            router.push("/thankyou");
        },
        onError: (d)=>console.log(d)
    });
    const [capture, captureResponse] = (0,useMutation/* useMutation */.D)(LEAD, {
        fetchPolicy: "network-only",
        onCompleted: (d)=>{
            router.push("/thankyou");
        },
        onError: (d)=>console.log(d)
    });
    // FUNCTIONS
    /************************************************************************* */ async function inquireJackalope(data) {
        inquire({
            variables: data
        });
    }
    async function logReferral(data) {
        var _IP_data;
        const IP = await axios/* default.get */.Z.get("https://geolocation-db.com/json/");
        logRef({
            variables: {
                IP: (_IP_data = IP.data) === null || _IP_data === void 0 ? void 0 : _IP_data.IPv4,
                ref: data
            }
        });
    }
    async function submitEmail(data) {
        capture({
            variables: data
        });
    }
    async function priceEmail(data) {
        logEmail({
            variables: {
                email: data.email
            }
        });
    }
    async function submitFeedback(data) {
        setValidation(data);
        validate({
            variables: {
                email: data.email,
                endResultStatement: data.result,
                problemStatement: data.problem,
                solutionStatement: data.solution
            }
        });
    }
    return {
        isLoading: captureResponse.loading || validationResponse.loading || inquiryResponse.loading || emailResponse.loading,
        openModal,
        setOpenModal,
        inquireJackalope,
        submitEmail,
        priceEmail,
        submitFeedback,
        validation,
        logReferral,
        response
    };
};
/* harmony default export */ var useOnboarding = (useDocuments);


/***/ }),

/***/ 3517:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "v": function() { return /* binding */ config; },
  "r": function() { return /* binding */ configSet; }
});

;// CONCATENATED MODULE: ./public/logo.png
/* harmony default export */ var logo = ({"src":"/_next/static/media/logo.84b77a51.png","height":407,"width":613,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAJFBMVEVMaXH4TSH/VCP3SyP6SCH5SSL4SB/6SB/7SCD3SCT5RyD4SCCUBaGTAAAADHRSTlMAFQoqRILQ65QjVptcvAuiAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAKElEQVR4nCXFuQ0AIBAEsdn7gf77RQInhkf6EwswWVSATVcfxzO3C10GQQBrpKbfmwAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./lib/pageConfig.js

// eslint-disable-next-line import/prefer-default-export
const config = {
    siteName: "jackrabbitops",
    blogTitle: "Blog",
    baseUrl: "jackrabbitops.com",
    websiteLogo: logo,
    twitterHandle: "@junaid.sudo",
    twitterCardType: "JackRabbit Blog",
    css: {
        primaryColor: "#111",
        accentColor: "#455A64",
        lightGray: "#eeeeee",
        backgroundColor: "#fff",
        black: "#111",
        white: "#fff",
        textColor: "#333",
        opacity: 0.7
    }
};
const privacy = {
    ...config,
    siteDescription: "Privacy policy for AI project manager ",
    defaultPageTitle: "Privacy | JackRabbit Ops"
};
const FAQ = {
    ...config,
    siteDescription: "Frequently asked questions for Jackrabbit Ops",
    defaultPageTitle: "FAQ | JackRabbit Ops"
};
const landing = {
    ...config,
    siteDescription: "Respond instantly to all your leads, qualify them and book meetings all on autopilot. All at a fraction of the cost of an SDR. ",
    defaultPageTitle: "Never miss a new customer | Jackrabbit Ops "
};
const demo = {
    ...config,
    siteDescription: "See Jackrabbit Ops in action, instantly responding to RFQs and qualifying the leads for you.",
    defaultPageTitle: "Instantly qualify leads | Jackrabbit Ops "
};
const offer = {
    ...config,
    siteDescription: "Try for free. Upgrade to the low-cost paid plan of $16/user to unlock your team's success.",
    defaultPageTitle: "Pricing | JackRabbit Ops"
};
const thankYou = {
    ...config,
    siteDescription: "Our team will be in touch to get you onboarded for your AI project manager.",
    defaultPageTitle: "Get In Touch | JackRabbit Ops"
};
const blogHome = {
    ...config,
    siteDescription: "Explore project management best practices and latest news with Jackrabbit Ops.",
    defaultPageTitle: "Blog | JackRabbit Ops"
};
const features = {
    ...config,
    siteDescription: "Jackrabbit Ops AI manager recognizes roadblocks and highlights them to roles that can solve them.",
    defaultPageTitle: "AI Manager Features | JackRabbit Ops"
};
const challenge = {
    ...config,
    siteDescription: "Productive team or your money back",
    defaultPageTitle: "90 Day Challenge | JackRabbit Ops"
};
const configSet = {
    FAQ,
    features,
    privacy,
    landing,
    blogHome,
    offer,
    challenge,
    thankYou,
    demo
};


/***/ }),

/***/ 4213:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ pages_Home; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./utils/seo.js
var seo = __webpack_require__(3298);
// EXTERNAL MODULE: ./lib/pageConfig.js + 1 modules
var pageConfig = __webpack_require__(3517);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./components/head.jsx


function HeadComponent() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                src: "https://cdnjs.cloudflare.com/ajax/libs/three.js/r134/three.min.js",
                async: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                src: "https://cdn.jsdelivr.net/npm/vanta/dist/vanta.waves.min.js",
                async: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                src: "https://embed.typeform.com/next/embed.js",
                async: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "viewport",
                content: "minimum-scale=1, initial-scale=1, width=device-width"
            }),
             true && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        strategy: "afterInteractive",
                        dangerouslySetInnerHTML: {
                            __html: '\n          (function(c,l,a,r,i,t,y){\n            c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};\n            t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;\n            y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);\n        })(window, document, "clarity", "script", "duvu3rlmwn");'
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        async: true,
                        src: "https://www.googletagmanager.com/gtag/js?id=G-30037DH1EH"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        dangerouslySetInnerHTML: {
                            __html: "\n        window.dataLayer = window.dataLayer || [];\n        function gtag(){dataLayer.push(arguments);}\n        gtag('js', new Date());\n        gtag('config', 'G-30037DH1EH');\n      "
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        strategy: "afterInteractive",
                        dangerouslySetInnerHTML: {
                            __html: "\n              !function(e,t,n,s,u,a){e.twq||(s=e.twq=function(){s.exe?s.exe.apply(s,arguments):s.queue.push(arguments); },s.version='1.1',s.queue=[],u=t.createElement(n),u.async=!0,u.src='https://static.ads-twitter.com/uwt.js', a=t.getElementsByTagName(n)[0],a.parentNode.insertBefore(u,a))}(window,document,'script'); twq('config','ofdgw');"
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "apple-touch-icon",
                sizes: "180x180",
                href: "/apple-touch-icon.png"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "icon",
                type: "image/png",
                sizes: "16x16",
                href: "/favicon.ico"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "manifest",
                href: "/site.webmanifest"
            })
        ]
    });
}

// EXTERNAL MODULE: ./components/container/base.jsx + 3 modules
var base = __webpack_require__(5216);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@typeform/embed-react/build/index.js
var build = __webpack_require__(2606);
;// CONCATENATED MODULE: ./components/landing/icons.jsx


const OPTIONS = [
    {
        name: "Cannabis"
    },
    {
        name: "Natural Health"
    },
    {
        name: "Confectionary"
    },
    {
        name: "Cosmetics"
    },
    {
        name: "Pharmaceutical"
    }
];
function Features() {
    const [counter, setCounter] = useState(2);
    useEffect(()=>{
        const interval = setInterval(()=>{
            setCounter((counter)=>counter + 1 > 6 ? 2 : counter + 1);
        }, 2600);
        return ()=>{
            clearInterval(interval);
        };
    }, []);
    return /*#__PURE__*/ _jsx("div", {
        children: /*#__PURE__*/ _jsx("div", {
            className: "bg-gray-200 rounded-lg"
        })
    });
}

// EXTERNAL MODULE: ./node_modules/react-flip-move/dist/react-flip-move.es.js
var react_flip_move_es = __webpack_require__(7794);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/20/solid/esm/CheckIcon.js
var esm_CheckIcon = __webpack_require__(4589);
;// CONCATENATED MODULE: ./components/landing/marquee.jsx




function Carousel() {
    const initialItems = [
        {
            name: "Tom Belfort",
            company: "Stratton",
            date: "26/5/2023"
        },
        {
            name: "Zig Ziglar",
            company: "6sense",
            date: "27/5/2023"
        },
        {
            name: "Aaron Ross",
            company: "Drift",
            date: "28/5/2023"
        },
        {
            name: "Mary Ash",
            company: "Clari",
            date: "29/5/2023"
        }
    ];
    const [items, setItems] = (0,react.useState)(initialItems);
    const [counter, setCounter] = (0,react.useState)(2);
    (0,react.useEffect)(()=>{
        const interval = setInterval(()=>{
            setItems((prevItems)=>{
                const newItems = [
                    ...prevItems
                ];
                const lastItem = newItems.pop();
                return [
                    lastItem,
                    ...newItems
                ];
            });
        }, 3000);
        return ()=>clearInterval(interval);
    }, []);
    (0,react.useEffect)(()=>{
        const interval = setInterval(()=>{
            setCounter((prevCounter)=>{
                return prevCounter >= 7 ? 2 : prevCounter + 1;
            });
        }, 500);
        return ()=>clearInterval(interval);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "lg:h-[50vh] max-w-md mx-auto overflow-hidden",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_flip_move_es/* default */.Z, {
            children: items.map((item, idx)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mb-4 p-4 border border-gray-100 bg-white shadow-sm rounded-lg grid grid-cols-5 justify-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "col-span-3",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-xl font-header",
                                    children: idx < 2 ? "Incoming lead" : idx < 3 ? "Qualifying lead" : "Scheduled Call"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-gray-400 text-sm mt-3 font-header",
                                    children: idx < 2 ? "".concat(item.name, " from ").concat(item.company) : idx < 3 ? "".concat(counter, " qualifying correspondence") : "Booked for ".concat(item.date)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-span-2",
                            children: idx < 2 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "font-semibold text-center bg-zinc-300 rounded-lg p-4 w-42",
                                children: "Incoming -"
                            }) : idx < 3 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "font-semibold items-center justify-center bg-blue-500 text-white rounded-lg p-4 flex flex-row gap-2",
                                children: [
                                    "Qualifying",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                        className: "animate-spin h-5 w-5 self-center",
                                        fill: "currentColor",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        viewBox: "0 0 40 40",
                                        enableBackground: "new 0 0 40 40",
                                        xml: "preserve",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                opacity: "0.2",
                                                d: "M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946 s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634 c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0 C22.32,8.481,24.301,9.057,26.013,10.047z"
                                            })
                                        ]
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "font-semibold items-center justify-center bg-green-500 text-white rounded-lg p-4 flex flex-row gap-2",
                                children: [
                                    "Automated",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_CheckIcon/* default */.Z, {
                                        className: "h-6 w-6"
                                    })
                                ]
                            })
                        })
                    ]
                }, item.name))
        })
    });
} // import { useEffect, useState } from "react";
 // import { CheckIcon } from "@heroicons/react/20/solid";
 // export default function Marquee() {
 //   const [counter, setCounter] = useState(2);
 //   useEffect(() => {
 //     const interval = setInterval(() => {
 //       setCounter((counter) => (counter + 1 > 6 ? 2 : counter + 1));
 //     }, 2600);
 //     return () => {
 //       clearInterval(interval);
 //     };
 //   }, []);
 //   console.log(counter);
 //   return (
 //     <div className="max-w-sm mx-auto flex flex-col  divide-y divide-dashed divide-zinc-400">
 // <div className="pt-2">
 // <div className="mb-4 p-4 border border-gray-100 bg-white shadow-sm rounded-lg  grid grid-cols-5 justify-between">
 //   <div className="col-span-3">
 //     <p className="text-xl font-header">Incoming lead</p>
 //     <p className="text-gray-400 text-sm mt-3 font-header">
 //       Ahmed from Tetra Sons
 //     </p>
 //   </div>
 //   <div className="col-span-2">
 //     <p className="font-semibold text-center  bg-zinc-300 rounded-lg p-4  w-42">
 //       Incoming -
 //     </p>{" "}
 //   </div>
 // </div>
 //         <div className="mb-4 p-4 border border-gray-100 bg-white shadow-sm rounded-lg  grid grid-cols-5 justify-between">
 //           <div className="col-span-3">
 //             <p className="text-xl font-header">Incoming lead</p>
 //             <p className="text-gray-400 text-sm mt-3 font-header">
 //               Ahmed from Tetra Sons
 //             </p>
 //           </div>
 //           <div className="col-span-2">
 //             <p className="font-semibold text-center  bg-zinc-300 rounded-lg p-4  w-42">
 //               Incoming -
 //             </p>{" "}
 //           </div>
 //         </div>
 //       </div>
 //       <div className="pt-2">
 //         <div className="mb-4 p-4 border border-gray-100 bg-white shadow-sm rounded-lg grid grid-cols-5  justify-between">
 //           <div className="col-span-3">
 //             <p className="text-xl font-header">Qualifying lead</p>
 //             <p className="text-gray-400 text-sm mt-3 font-header">
 //               7 qualifying correspondence
 //             </p>
 //           </div>
 //           <div className="col-span-2">
 // <p className="font-semibold bg-blue-500 text-white rounded-lg p-4 flex flex-row gap-2">
 //   Qualifying{" "}
 //   <svg
 //     className="animate-spin h-5 w-5  self-center"
 //     fill="currentColor"
 //     xmlns="http://www.w3.org/2000/svg"
 //     viewBox="0 0 40 40"
 //     enableBackground="new 0 0 40 40"
 //     xml="preserve"
 //   >
 //     <path
 //       opacity="0.2"
 //       d="M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946 s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634 c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z"
 //     />
 //     <path d="M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0 C22.32,8.481,24.301,9.057,26.013,10.047z" />
 //   </svg>
 // </p>{" "}
 //           </div>
 //         </div>
 //       </div>
 //       <div className="pt-2">
 //         <div className="mb-4 p-4 border border-gray-100 bg-white shadow-sm rounded-lg grid grid-cols-5 justify-between">
 //           <div className="col-span-3">
 //             <p className="text-xl font-header"> Scheduled Call</p>
 //             <p className="text-gray-400 text-sm mt-3 font-header">29/5/2023</p>
 //           </div>
 //           <div className="col-span-2">
 // <p className="font-semibold bg-green-500 text-white rounded-lg p-4 flex flex-row gap-2">
 //   Automated
 //   <CheckIcon className="h-6 w-6" />
 // </p>{" "}
 //           </div>
 //         </div>
 //       </div>
 //     </div>
 // <div className="relative w-full lg:col-span-3 flex justify-center overflow-y-hidden text-darkGray font-semibold">
 //   <div className="relative w-full">
 //     <div className="lg:py-2 animate-marquee whitespace-nowrap flex flex-col">
 //       {OPTIONS.map((entry, index) => (
 //         <span
 //           key={index}
 //           className={` my-2 bg-gray-50 p-4 w-full shadow-lg rounded-lg border ${
 //             counter === index && "text-jackOrange"
 //           }`}
 //         >
 //           {entry.name}
 //         </span>
 //       ))}
 //     </div>
 //     <div className="w-full absolute top-0 lg:py-2 animate-marquee2 whitespace-nowrap flex flex-col">
 //       {OPTIONS.map((entry, index) => (
 //         <span
 //           key={index}
 //           className={` my-2 bg-gray-50 p-4 w-full shadow-lg rounded-lg border ${
 //             counter - 5 === index && "text-jackOrange"
 //           }`}
 //         >
 //           {entry.name}
 //         </span>
 //       ))}
 //     </div>
 //     {/* <div className="h-24 w-full absolute top-0 left-0 bg-gradient-to-b from-black to-transparent">
 //       {" "}
 //     </div>
 //     <div className="h-24 w-full absolute bottom-0 left-0 bg-gradient-to-t from-black to-transparent">
 //       {" "}
 //     </div> */}
 //   </div>
 // </div>
 //   );
 // }

;// CONCATENATED MODULE: ./components/landing/hero.jsx







function Hero(param) {
    let { setOpen  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "bg-white",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative isolate overflow-hidden bg-gradient-to-b from-indigo-100/20",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mx-auto max-w-7xl pb-24 pt-10 sm:pb-32 lg:grid lg:grid-cols-2 lg:gap-x-8 lg:px-8 lg:py-40",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "px-6 lg:px-0 lg:pt-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mx-auto max-w-2xl",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "max-w-lg",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                className: "mt-10 text-5xl font-header tracking-tight text-gray-900 sm:text-7xl",
                                                children: "Never miss a new customer."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "mt-6 text-lg leading-8 text-gray-600",
                                                children: "Jackrabbit's AI will respond to leads and book meetings - just like your best sales person."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "mt-10 flex items-center gap-x-6",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: "https://sdr.jackrabbitops.com/register",
                                                        className: "w-max border border-gray-800 hover:text-gray-900 rounded-md px-6 py-2 bg-gray-900 text-white hover:bg-white",
                                                        children: "Get Access - 2mins"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: "/demo",
                                                        className: "font-medium w-max border-2 border-jackOrange hover:text-gray-900 rounded-md px-6 py-2 bg-orange-50 text-jackOrange hover:bg-gray-50",
                                                        children: "Test AI"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mt-20 sm:mt-24 md:mx-auto md:max-w-2xl lg:mx-0 lg:mt-0 lg:w-screen",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "absolute inset-y-0 right-1/2 -z-10 -mr-10 w-[200%] skew-x-[-30deg] bg-white shadow-xl shadow-orange-600/10 ring-1 ring-orange-50 md:-mr-20 lg:-mr-36",
                                        "aria-hidden": "true"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel, {})
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute inset-x-0 bottom-0 -z-10 h-24 bg-gradient-to-t from-white sm:h-32"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-[#F6800A]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "max-w-7xl mx-auto p-6 flex flex-row gap-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "/quote.png",
                            className: "h-5 w-5",
                            alt: "Quotation mark"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "font-medium text-lg",
                            children: [
                                "“Saves countless hours... [Jackrabbit Ops] has greatly improved how we implement and standardize activities.”",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "italic",
                                    children: "- Devon Lio, Director of Operations at ATG Pharma Inc"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/landing/form.jsx


function Example() {
    const [agreed, setAgreed] = useState(false);
    return /*#__PURE__*/ _jsx("div", {
        className: "relative",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "isolate bg-white px-6 py-24 sm:py-32 lg:px-8",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "absolute inset-x-0 top-[-10rem] -z-10 transform-gpu overflow-hidden blur-3xl sm:top-[-20rem]",
                    "aria-hidden": "true",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "relative left-1/2 -z-10 aspect-[1155/678] w-[36.125rem] max-w-none -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-[#ff80b5] to-jackOrange opacity-30 sm:left-[calc(50%-40rem)] sm:w-[72.1875rem]",
                        style: {
                            clipPath: "polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)"
                        }
                    })
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "mx-auto max-w-2xl text-center",
                    children: [
                        /*#__PURE__*/ _jsx("h2", {
                            className: "text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl",
                            children: "See Jackrabbit in Action"
                        }),
                        /*#__PURE__*/ _jsx("p", {
                            className: "mt-2 text-lg leading-8 text-gray-600",
                            children: "Fill the form and our AI will instantly reply and qualify you."
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("form", {
                    action: "#",
                    method: "POST",
                    className: "mx-auto mt-16 max-w-xl sm:mt-20",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "grid grid-cols-1 gap-x-8 gap-y-6 sm:grid-cols-2",
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "sm:col-span-2",
                                    children: [
                                        /*#__PURE__*/ _jsx("label", {
                                            htmlFor: "first-name",
                                            className: "block text-sm font-semibold leading-6 text-gray-900",
                                            children: "First name"
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "mt-2.5",
                                            children: /*#__PURE__*/ _jsx("input", {
                                                type: "text",
                                                name: "first-name",
                                                id: "first-name",
                                                autoComplete: "given-name",
                                                className: "block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "sm:col-span-2",
                                    children: [
                                        /*#__PURE__*/ _jsx("label", {
                                            htmlFor: "email",
                                            className: "block text-sm font-semibold leading-6 text-gray-900",
                                            children: "Email"
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "mt-2.5",
                                            children: /*#__PURE__*/ _jsx("input", {
                                                type: "email",
                                                name: "email",
                                                id: "email",
                                                autoComplete: "email",
                                                className: "block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "sm:col-span-2",
                                    children: [
                                        /*#__PURE__*/ _jsx("label", {
                                            htmlFor: "message",
                                            className: "block text-sm font-semibold leading-6 text-gray-900",
                                            children: "Message"
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "mt-2.5",
                                            children: /*#__PURE__*/ _jsx("textarea", {
                                                name: "message",
                                                id: "message",
                                                rows: 4,
                                                className: "block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6",
                                                defaultValue: ""
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "mt-10",
                            children: /*#__PURE__*/ _jsx("button", {
                                type: "submit",
                                className: "block w-full rounded-md bg-indigo-600 px-3.5 py-2.5 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600",
                                children: "Let's talk"
                            })
                        })
                    ]
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./components/panel/chatHero.jsx




function chatHero_Hero(param) {
    let { setOpen  } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: "bg-black text-white py-20 lg:py-40",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "flex flex-col lg:grid grid-cols-5 gap-12 max-w-7xl mx-auto w-full px-6",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "col-span-2",
                    children: [
                        /*#__PURE__*/ _jsx("h1", {
                            className: "mt-8 text-5xl lg:text-6xl font-header tracking-wide font-bold text-left",
                            children: "Get answers for any process. Instantly!"
                        }),
                        /*#__PURE__*/ _jsx("p", {
                            className: "text-lg my-6 text-left text-gray-400 max-w-sm lg:max-w-2xl mx-auto ",
                            children: "From operation processes to sale flows, Jackrabbit Ops brings your processes to life. You can ask questions, get summaries, find information, and more."
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "flex flex-col lg:flex-row gap-2 lg:gap-4",
                            children: /*#__PURE__*/ _jsx(Link, {
                                href: "/pdf",
                                className: "w-max border border-gray-800 text-gray-900 rounded-md px-6 py-2 hover:bg-gray-900 hover:text-white bg-white",
                                children: "Try the demo →"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("img", {
                    src: "/text.png",
                    className: "col-span-3 rounded-lg"
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./components/panel/compare.jsx



const tiers = [
    {
        name: "Human",
        id: "tier-basic",
        href: "#",
        priceMonthly: "$9",
        description: "Quis suspendisse ut fermentum neque vivamus non tellus.",
        mostPopular: false
    },
    {
        name: "Jackrabbit",
        id: "tier-essential",
        href: "#",
        priceMonthly: "$29",
        description: "Quis eleifend a tincidunt pellentesque. A tempor in sed.",
        mostPopular: true
    }
];
const features = [
    {
        name: "Cost",
        tiers: {
            Human: "Minimum $1000/hire per month",
            Jackrabbit: "$349 for the entire team"
        }
    },
    {
        name: "Operation Hours",
        tiers: {
            Human: "Limited to 8 hours a day",
            Jackrabbit: "Operates 24/7"
        }
    },
    {
        name: "Speed of Response:",
        tiers: {
            Human: "Dependent on individual speed, can take hours or days",
            Jackrabbit: "Instant response, no waiting time for prospects"
        }
    },
    {
        name: "Efficiency",
        tiers: {
            Human: "Prone to errors or oversights, can miss leads",
            Jackrabbit: "Never misses a lead"
        }
    },
    {
        name: "Scalability",
        tiers: {
            Human: "More leads require more hires",
            Jackrabbit: "Handles any volume of leads"
        }
    }
];
function classNames() {
    for(var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++){
        classes[_key] = arguments[_key];
    }
    return classes.filter(Boolean).join(" ");
}
function compare_Example() {
    return /*#__PURE__*/ _jsx("div", {
        className: "bg-white py-24 ",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "mx-auto max-w-7xl px-6 lg:px-8",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "mx-auto max-w-4xl text-center",
                    children: /*#__PURE__*/ _jsx("p", {
                        className: "mt-2 text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl",
                        children: "What's the difference between Humans and Jackrabbit Ops?"
                    })
                }),
                /*#__PURE__*/ _jsx("p", {
                    className: "mx-auto mt-6 max-w-2xl text-center text-lg leading-8 text-gray-600",
                    children: "If you have a growing business, chances are you'll quickly outgrow the capacity of manual follow-ups. Jackrabbit Ops scales with your needs, providing a responsive system where every lead is instantly engaged, qualified, and managed, keeping your team's focus on closing deals, not chasing them."
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "mx-auto mt-12 max-w-md space-y-8 sm:mt-16 lg:hidden",
                    children: tiers.map((tier)=>/*#__PURE__*/ _jsxs("section", {
                            className: classNames(tier.mostPopular ? "rounded-xl bg-gray-400/5 ring-1 ring-inset ring-gray-200" : "", "p-8"),
                            children: [
                                /*#__PURE__*/ _jsx("h3", {
                                    className: "mt-2 flex items-baseline gap-x-1 text-gray-900",
                                    children: /*#__PURE__*/ _jsxs("span", {
                                        className: "text-4xl font-bold",
                                        children: [
                                            " ",
                                            tier.name
                                        ]
                                    })
                                }),
                                tier.mostPopular && /*#__PURE__*/ _jsx("a", {
                                    href: tier.href,
                                    "aria-describedby": tier.id,
                                    className: "border-gray-800 hover:text-gray-900 bg-gray-900 text-white hover:bg-white mt-8 block rounded-md py-2 px-3 text-center text-sm font-semibold leading-6 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600",
                                    children: "Apply - 2 mins"
                                }),
                                /*#__PURE__*/ _jsx("ul", {
                                    role: "list",
                                    className: "mt-10 space-y-4 text-sm leading-6 text-gray-900",
                                    children: features.map((feature)=>feature.tiers[tier.name] ? /*#__PURE__*/ _jsxs("li", {
                                            className: "flex gap-x-3",
                                            children: [
                                                tier.mostPopular ? /*#__PURE__*/ _jsx(HandThumbUpIcon, {
                                                    className: "h-6 w-5 flex-none text-jackOrange",
                                                    "aria-hidden": "true"
                                                }) : /*#__PURE__*/ _jsx(HandThumbDownIcon, {
                                                    className: "h-6 w-5 flex-none text-gray-800",
                                                    "aria-hidden": "true"
                                                }),
                                                /*#__PURE__*/ _jsxs("span", {
                                                    children: [
                                                        feature.name,
                                                        " ",
                                                        typeof feature.tiers[tier.name] === "string" ? /*#__PURE__*/ _jsxs("span", {
                                                            className: "text-sm leading-6 text-gray-500",
                                                            children: [
                                                                "(",
                                                                feature.tiers[tier.name],
                                                                ")"
                                                            ]
                                                        }) : null
                                                    ]
                                                })
                                            ]
                                        }, feature.name) : null)
                                })
                            ]
                        }, tier.id))
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "isolate mt-20 hidden lg:block",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "relative -mx-8",
                        children: [
                            tiers.some((tier)=>tier.mostPopular) ? /*#__PURE__*/ _jsx("div", {
                                className: "absolute inset-x-4 inset-y-0 -z-10 flex",
                                children: /*#__PURE__*/ _jsx("div", {
                                    className: "flex w-1/4 px-4",
                                    "aria-hidden": "true",
                                    style: {
                                        marginLeft: "".concat((tiers.findIndex((tier)=>tier.mostPopular) + 1) * 25, "%")
                                    },
                                    children: /*#__PURE__*/ _jsx("div", {
                                        className: "w-full rounded-t-xl border-x border-t border-gray-900/10 bg-gray-400/5"
                                    })
                                })
                            }) : null,
                            /*#__PURE__*/ _jsxs("table", {
                                className: "w-full table-fixed border-separate border-spacing-x-8 text-left",
                                children: [
                                    /*#__PURE__*/ _jsx("caption", {
                                        className: "sr-only",
                                        children: "Pricing plan comparison"
                                    }),
                                    /*#__PURE__*/ _jsxs("colgroup", {
                                        children: [
                                            /*#__PURE__*/ _jsx("col", {
                                                className: "w-1/4"
                                            }),
                                            /*#__PURE__*/ _jsx("col", {
                                                className: "w-1/4"
                                            }),
                                            /*#__PURE__*/ _jsx("col", {
                                                className: "w-1/4"
                                            }),
                                            /*#__PURE__*/ _jsx("col", {
                                                className: "w-1/4"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("tbody", {
                                        children: [
                                            /*#__PURE__*/ _jsxs("tr", {
                                                children: [
                                                    /*#__PURE__*/ _jsx("th", {
                                                        scope: "row",
                                                        children: /*#__PURE__*/ _jsx("span", {
                                                            className: "sr-only",
                                                            children: "Price"
                                                        })
                                                    }),
                                                    tiers.map((tier)=>/*#__PURE__*/ _jsx("td", {
                                                            className: "px-6 pt-2 xl:px-8",
                                                            children: /*#__PURE__*/ _jsxs("div", {
                                                                className: "flex h-full flex-col",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "flex h-full w-full items-baseline gap-x-1 text-gray-900 pt-6",
                                                                        children: /*#__PURE__*/ _jsx("span", {
                                                                            className: "text-4xl font-bold mx-auto",
                                                                            children: tier.name
                                                                        })
                                                                    }),
                                                                    tier.mostPopular ? /*#__PURE__*/ _jsx("a", {
                                                                        href: tier.href,
                                                                        className: "mt-8 w-full text-center border border-gray-800 hover:text-gray-900 rounded-md px-6 py-2 bg-gray-900 text-white hover:bg-white",
                                                                        children: "Apply - 2 mins"
                                                                    }) : /*#__PURE__*/ _jsx("div", {
                                                                        className: "mt-8 block rounded-md py-2 px-3 text-center text-sm font-semibold leading-6 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 text-white",
                                                                        children: "|"
                                                                    })
                                                                ]
                                                            })
                                                        }, tier.id))
                                                ]
                                            }),
                                            features.map((feature)=>/*#__PURE__*/ _jsxs("tr", {
                                                    children: [
                                                        /*#__PURE__*/ _jsxs("th", {
                                                            scope: "row",
                                                            className: "py-4 text-sm font-normal leading-6 text-gray-900",
                                                            children: [
                                                                feature.name,
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "absolute inset-x-8 mt-4 h-px bg-gray-900/5"
                                                                })
                                                            ]
                                                        }),
                                                        tiers.map((tier)=>/*#__PURE__*/ _jsx("td", {
                                                                className: "px-6 py-4 xl:px-8",
                                                                children: typeof feature.tiers[tier.name] === "string" ? /*#__PURE__*/ _jsx("div", {
                                                                    className: "text-center text-sm leading-6 text-gray-500",
                                                                    children: feature.tiers[tier.name]
                                                                }) : /*#__PURE__*/ _jsxs(_Fragment, {
                                                                    children: [
                                                                        feature.tiers[tier.name] === true ? /*#__PURE__*/ _jsx(CheckIcon, {
                                                                            className: "mx-auto h-5 w-5 text-indigo-600",
                                                                            "aria-hidden": "true"
                                                                        }) : /*#__PURE__*/ _jsx(MinusIcon, {
                                                                            className: "mx-auto h-5 w-5 text-gray-400",
                                                                            "aria-hidden": "true"
                                                                        }),
                                                                        /*#__PURE__*/ _jsxs("span", {
                                                                            className: "sr-only",
                                                                            children: [
                                                                                feature.tiers[tier.name] === true ? "Included" : "Not included",
                                                                                " ",
                                                                                "in ",
                                                                                tier.name
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            }, tier.id))
                                                    ]
                                                }, feature.name))
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/outline/esm/GlobeAltIcon.js
var GlobeAltIcon = __webpack_require__(7950);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/outline/esm/ChatBubbleLeftRightIcon.js
var ChatBubbleLeftRightIcon = __webpack_require__(2418);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/outline/esm/UsersIcon.js
var UsersIcon = __webpack_require__(7543);
// EXTERNAL MODULE: ./node_modules/react-youtube/dist/YouTube.esm.js
var YouTube_esm = __webpack_require__(3913);
;// CONCATENATED MODULE: ./components/landing/features.jsx



const features_features = [
    {
        name: "Handles RFQs",
        description: "100% of the RFQs made for your business get personalized replies within an hour. ",
        icon: GlobeAltIcon/* default */.Z
    },
    {
        name: "Qualifies leads",
        description: "Evaluate all leads and identifies the customers with intent to buy.",
        icon: ChatBubbleLeftRightIcon/* default */.Z
    },
    {
        name: "Books Meetings",
        description: "Get prospects booking meetings to close more sales.",
        icon: UsersIcon/* default */.Z
    }
];
function features_Example() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: "features",
        className: "bg-white pt-24 sm:pt-32",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "mx-auto max-w-7xl px-6 lg:px-8",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "text-4xl font-header tracking-tight text-gray-900 sm:text-6xl text-center",
                    children: "Close more sales!"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mx-auto mt-20 max-w-2xl lg:max-w-none",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("dl", {
                        className: "grid max-w-xl grid-cols-1 gap-x-8 gap-y-16 lg:max-w-none lg:grid-cols-3",
                        children: features_features.map((feature)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col h-full justify-between p-4 py-6 rounded-xl bg-white ",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("dt", {
                                        className: "font-semibold flex flex-col items-center justify-center leading-7 text-zinc-900 text-2xl",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-orange-50",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(feature.icon, {
                                                    className: "h-12 w-12 text-jackOrange",
                                                    "aria-hidden": "true"
                                                })
                                            }),
                                            feature.name
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                        className: "mt-5 flex flex-auto flex-col items-center justify-center text-center text-lg leading-7 text-zinc-600",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "h-max",
                                            children: feature.description
                                        })
                                    })
                                ]
                            }, feature.name))
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "hidden lg:flex mx-auto mt-20 max-w-2xl lg:max-w-none flex justify-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(YouTube_esm/* default */.Z, {
                        videoId: "nAo96hXq0kQ",
                        opts: {
                            height: "360",
                            width: "670"
                        }
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "lg:hidden mx-auto mt-20 max-w-2xl lg:max-w-none flex justify-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(YouTube_esm/* default */.Z, {
                        videoId: "nAo96hXq0kQ",
                        opts: {
                            height: "320",
                            width: "320"
                        }
                    })
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./components/landing/price.jsx


const includedFeatures = [
    "3 Sales Rep Access",
    "Track all your leads from one place",
    "Train AI on your business profile",
    "1000 emails sent or 10 meetings booked"
];
function price_Example() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "price",
        className: " relative isolate bg-white py-24",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute inset-x-0 -top-3 -z-10 transform-gpu overflow-hidden px-36 blur-3xl",
                "aria-hidden": "true",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mx-auto aspect-[1155/678] w-[72.1875rem] bg-gradient-to-tr from-[#ff80b5] to-[#F67F0A] opacity-30",
                    style: {
                        clipPath: "polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)"
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mx-auto max-w-7xl px-6 lg:px-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mx-auto max-w-3xl sm:text-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "text-4xl font-header tracking-tight text-gray-900 sm:text-6xl",
                            children: "Your sales funnel on autopilot at 10% of the cost."
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mx-auto mt-16 max-w-2xl rounded-3xl ring-1 ring-gray-200 sm:mt-20 lg:mx-0 lg:flex lg:max-w-none",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "p-8 sm:p-10 lg:flex-auto",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "text-2xl font-bold tracking-tight text-gray-900",
                                        children: "Simple no-tricks pricing"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mt-6 text-base leading-7 text-gray-600",
                                        children: "Jackrabbit Ops AI system outperforms a traditional SDR by being available to customers 24/7 with real-time company knowledge, at 10% of the cost."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mt-10 flex items-center gap-x-4",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                className: "flex-none text-sm font-semibold leading-6 text-zinc-700",
                                                children: "What's included"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "h-px flex-auto bg-zinc-400"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        role: "list",
                                        className: "mt-8 grid grid-cols-1 gap-4 text-sm leading-6 text-gray-600 sm:grid-cols-2 sm:gap-6",
                                        children: includedFeatures.map((feature)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                className: "flex gap-x-3",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_CheckIcon/* default */.Z, {
                                                        className: "h-6 w-5 flex-none text-jackOrange",
                                                        "aria-hidden": "true"
                                                    }),
                                                    feature
                                                ]
                                            }, feature))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "-mt-2 p-2 lg:mt-0 lg:w-full lg:max-w-md lg:flex-shrink-0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "rounded-2xl bg-gray-50 py-10 text-center ring-1 ring-inset ring-gray-900/5 lg:flex lg:flex-col lg:justify-center lg:py-16",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mx-auto max-w-xs px-8",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-base font-semibold text-gray-600",
                                                children: "Early Access Pricing"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: "mt-6 flex items-baseline justify-center gap-x-2",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "text-5xl font-bold tracking-tight text-gray-900",
                                                        children: "$99"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "text-sm font-semibold leading-6 tracking-wide text-gray-600",
                                                        children: "/ month"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "https://sdr.jackrabbitops.com/register",
                                                className: "mt-10 block w-full rounded-md px-3 py-2 border border-gray-800 hover:text-gray-900 bg-gray-900 text-white hover:bg-white text-center font-semibold shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 ",
                                                children: "Get access - 2mins"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "mt-6 text-xs leading-5 text-gray-600",
                                                children: "Invoices and receipts available for easy company reimbursement."
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/landing/index.jsx
//COMPONENTS








function Home(param) {
    let { setOpen , articles =[]  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "h-full w-full bg-white",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(base/* default */.Z, {
            setOpen: setOpen,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero, {
                    setOpen: setOpen
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(features_Example, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(price_Example, {})
            ]
        })
    });
}

// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(7536);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/transitions/transition.js + 4 modules
var transition = __webpack_require__(4829);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/dialog/dialog.js + 8 modules
var dialog = __webpack_require__(9545);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/outline/esm/XMarkIcon.js
var XMarkIcon = __webpack_require__(1415);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/outline/esm/ChevronUpIcon.js
var ChevronUpIcon = __webpack_require__(6610);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/outline/esm/ChevronDownIcon.js
var ChevronDownIcon = __webpack_require__(3245);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/outline/esm/CheckIcon.js
var outline_esm_CheckIcon = __webpack_require__(2911);
// EXTERNAL MODULE: ./hooks/useOnboarding.js + 1 modules
var useOnboarding = __webpack_require__(6337);
// EXTERNAL MODULE: ./components/inputs/whiteText.jsx
var whiteText = __webpack_require__(7827);
// EXTERNAL MODULE: ./components/loading/page.jsx
var page = __webpack_require__(7733);
;// CONCATENATED MODULE: ./components/modal/form.jsx





//HOOKS

//COMPONENTS


function CoverModal(param) {
    let { open , setOpen  } = param;
    const { isLoading , submitEmail  } = (0,useOnboarding/* default */.Z)();
    const [current, setCurrent] = (0,react.useState)(0);
    const { register , trigger , handleSubmit , formState: { errors  }  } = (0,index_esm/* useForm */.cI)();
    if (isLoading) return /*#__PURE__*/ (0,jsx_runtime.jsx)(page/* default */.Z, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition.Root */.u.Root, {
        show: open,
        as: react.Fragment,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* Dialog */.V, {
            as: "div",
            className: "relative z-[60]",
            onClose: setOpen,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition.Child */.u.Child, {
                    as: react.Fragment,
                    enter: "ease-out duration-300",
                    enterFrom: "opacity-0",
                    enterTo: "opacity-100",
                    leave: "ease-in duration-200",
                    leaveFrom: "opacity-100",
                    leaveTo: "opacity-0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "fixed inset-0 bg-neutral-700 bg-opacity-90 transition-opacity"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "fixed inset-0 z-10 overflow-y-auto",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition.Child */.u.Child, {
                            as: react.Fragment,
                            enter: "ease-out duration-300",
                            enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                            enterTo: "opacity-100 translate-y-0 sm:scale-100",
                            leave: "ease-in duration-200",
                            leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
                            leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* Dialog.Panel */.V.Panel, {
                                className: "relative transform overflow-hidden w-full lg:w-5/6 h-5/6",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-full flex items-end justify-end mb-1",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            type: "button",
                                            onClick: ()=>setOpen(false),
                                            className: "text-softWhite hover:text-gray-300",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(XMarkIcon/* default */.Z, {
                                                className: "h-8 w-8",
                                                "aria-hidden": "true"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: " bg-black px-4 pb-4 pt-5 text-left shadow-xl transition-all w-full h-full rounded-xl sm:p-6",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                                onSubmit: handleSubmit(submitEmail),
                                                className: "max-w-4xl mx-auto flex flex-col items-center text-center justify-center h-[80vh] text-softWhite",
                                                children: [
                                                    current === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Name, {
                                                        setCurrent: setCurrent,
                                                        register: register,
                                                        trigger: trigger,
                                                        errors: errors
                                                    }),
                                                    current === 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Email, {
                                                        setCurrent: setCurrent,
                                                        register: register,
                                                        trigger: trigger,
                                                        errors: errors
                                                    }),
                                                    current === 2 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Company, {
                                                        setCurrent: setCurrent,
                                                        register: register,
                                                        errors: errors
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: " w-full flex items-end justify-end text-softWhite",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                        type: "button",
                                                        onClick: ()=>setCurrent((current)=>current - 1),
                                                        disabled: current === 0,
                                                        className: "".concat(current === 0 ? "bg-gray-700" : "bg-[#0042AC] hover:bg-blue-700", " text-lg  px-2 py-2 rounded-l-md flex flex-row gap-2 items-center border-r border-gray-400"),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronUpIcon/* default */.Z, {
                                                            className: "h-4 w-4",
                                                            "aria-hidden": "true"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                        type: "button",
                                                        disabled: current === 2,
                                                        onClick: ()=>setCurrent((current)=>current + 1),
                                                        className: "".concat(current === 2 ? "bg-gray-700" : "bg-[#0042AC] hover:bg-blue-700", " text-lg  px-2 py-2 rounded-r-md flex flex-row gap-2 items-center "),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronDownIcon/* default */.Z, {
                                                            className: "h-4 w-4",
                                                            "aria-hidden": "true"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                })
            ]
        })
    });
}
const Name = (param)=>{
    let { setCurrent , register , trigger , errors  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: "font-light text-3xl text-left w-full text-gray-50",
                children: "1. What's your full name?"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "p-6 w-full ",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(whiteText/* default */.Z, {
                        title: "Business Email",
                        name: "name",
                        type: "text",
                        placeholder: "Type your answer here...",
                        register: register,
                        errors: errors === null || errors === void 0 ? void 0 : errors.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full flex items-start justify-start mt-4 ",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            type: "button",
                            className: "bg-[#0042AC] text-lg hover:bg-blue-700 px-4 py-2 rounded-md flex flex-row gap-2 items-center",
                            onClick: async ()=>{
                                const safe = await trigger([
                                    "name"
                                ]);
                                if (safe) setCurrent(1);
                            },
                            children: [
                                "OK",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(outline_esm_CheckIcon/* default */.Z, {
                                    className: "h-5 w-5",
                                    "aria-hidden": "true"
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
const Email = (param)=>{
    let { setCurrent , register , trigger , errors  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: "font-light text-3xl text-left w-full text-gray-50",
                children: "2. What's your email address?"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "p-6 w-full ",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(whiteText/* default */.Z, {
                        title: "Business Email",
                        name: "email",
                        type: "email",
                        placeholder: "elon@spaceX.com",
                        register: register,
                        errors: errors === null || errors === void 0 ? void 0 : errors.email,
                        valid: {
                            maxLength: (v)=>v.length <= 50 || "The email should have at most 50 characters",
                            matchPattern: (v)=>/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || "Email address must be a valid address"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full flex items-start justify-start mt-4 ",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            type: "button",
                            className: "bg-[#0042AC] text-lg hover:bg-blue-700 px-4 py-2 rounded-md flex flex-row gap-2 items-center",
                            onClick: async ()=>{
                                const safe = await trigger([
                                    "email"
                                ]);
                                if (safe) setCurrent(2);
                            },
                            children: [
                                "OK",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(outline_esm_CheckIcon/* default */.Z, {
                                    className: "h-5 w-5",
                                    "aria-hidden": "true"
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
const Company = (param)=>{
    let { setCurrent , register , errors  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: "font-light text-3xl text-left w-full text-gray-50",
                children: "3. What does your company do ?"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-left w-full text-gray-500 px-6 pt-1",
                children: "Any important info we should know on what you do? and company goals ?"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "p-6 w-full ",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(whiteText/* default */.Z, {
                        title: "Business Email",
                        name: "company",
                        type: "text",
                        placeholder: "type your answer here...",
                        register: register,
                        errors: errors === null || errors === void 0 ? void 0 : errors.company
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full flex items-start justify-start mt-4 ",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            type: "submit",
                            className: "bg-[#0042AC] text-lg hover:bg-blue-700 px-4 py-2 rounded-md flex flex-row gap-2 items-center",
                            children: [
                                "SUBMIT",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(outline_esm_CheckIcon/* default */.Z, {
                                    className: "h-5 w-5",
                                    "aria-hidden": "true"
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./pages/index.js





// COMPONENTS



var __N_SSG = true;
function pages_Home(param) {
    let { articles =[]  } = param;
    const [open, setOpen] = (0,react.useState)(false);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "font-copy bg-black min-h-screen",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadComponent, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                ...(0,seo/* createSEOPageConfig */.Cd)(pageConfig/* configSet.landing */.r.landing)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CoverModal, {
                open: open,
                setOpen: setOpen
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Home, {
                setOpen: setOpen,
                articles: articles
            })
        ]
    });
}


/***/ }),

/***/ 3298:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cd": function() { return /* binding */ createSEOPageConfig; },
/* harmony export */   "JV": function() { return /* binding */ BlogSeo; },
/* harmony export */   "WQ": function() { return /* binding */ createSEOConfig; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2962);
/* harmony import */ var _lib_pageConfig__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3517);



const getImage = function() {
    let data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (data.imageUrl) {
        return [
            {
                url: data.imageUrl,
                width: 600,
                height: 300,
                alt: data.title
            }
        ];
    }
    if (data.slug) {
        return [
            {
                url: "/api/blog-image/".concat(data.slug),
                width: 600,
                height: 300,
                alt: data.title
            }
        ];
    }
    return [
        {
            url: _lib_pageConfig__WEBPACK_IMPORTED_MODULE_2__/* .config.websiteLogo */ .v.websiteLogo,
            width: 280,
            height: 280,
            alt: "JRO"
        }
    ];
};
function BlogSeo(param) {
    let { data  } = param;
    if (!data) return null;
    const description = data.seoDescription ? data.seoDescription : _lib_pageConfig__WEBPACK_IMPORTED_MODULE_2__/* .config.siteDescription */ .v.siteDescription;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .ArticleJsonLd */ .dX, {
        url: data.canonicalUrl,
        title: data.title,
        images: getImage(data).map((file)=>file.url),
        datePublished: data.publishDate,
        dateModified: data.modifiedDate,
        authorName: _lib_pageConfig__WEBPACK_IMPORTED_MODULE_2__/* .config.author */ .v.author,
        publisherName: _lib_pageConfig__WEBPACK_IMPORTED_MODULE_2__/* .config.author */ .v.author,
        publisherLogo: "https://www.example.com/photos/logo.jpg",
        description: description
    });
}
function createSEOConfig() {
    let data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const title = data.title || _lib_pageConfig__WEBPACK_IMPORTED_MODULE_2__/* .config.defaultPageTitle */ .v.defaultPageTitle;
    const description = data.seoDescription ? data.seoDescription : _lib_pageConfig__WEBPACK_IMPORTED_MODULE_2__/* .config.siteDescription */ .v.siteDescription;
    return {
        title,
        description,
        openGraph: {
            type: "website",
            locale: "en_US",
            url: data.canonicalUrl,
            title,
            description,
            images: getImage(data),
            site_name: _lib_pageConfig__WEBPACK_IMPORTED_MODULE_2__/* .config.siteName */ .v.siteName
        },
        twitter: {
            handle: _lib_pageConfig__WEBPACK_IMPORTED_MODULE_2__/* .config.twitterHandle */ .v.twitterHandle,
            site: _lib_pageConfig__WEBPACK_IMPORTED_MODULE_2__/* .config.twitterHandle */ .v.twitterHandle,
            cardType: _lib_pageConfig__WEBPACK_IMPORTED_MODULE_2__/* .config.twitterCardType */ .v.twitterCardType
        }
    };
}
function createSEOPageConfig() {
    let config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!config) return null;
    const title = config.defaultPageTitle;
    const description = config.siteDescription;
    return {
        title,
        description,
        openGraph: {
            type: "website",
            locale: "en_US",
            url: config.canonicalUrl,
            title,
            description,
            images: getImage(config),
            site_name: config.siteName
        },
        twitter: {
            handle: config.twitterHandle,
            site: config.twitterHandle,
            cardType: config.twitterCardType
        }
    };
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [862,962,594,536,874,216,774,888,179], function() { return __webpack_exec__(5557); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);